import AxiosInstance from "../instance";

const initText2ArtJob = async (payload: string) => {
    const response = await AxiosInstance.getInstance().post("/init-text2art", payload);
    return response;
};

const collectText2ArtJob = async (payload: string) => {
    const response = await AxiosInstance.getInstance().get("/collect-text2art", {
        params: { jobId: payload},
        responseType: 'blob'
    });
    return response;
};

export {initText2ArtJob, collectText2ArtJob};



// WEBPACK FOOTER //
// ./src/api/models/Text2Art.ts